// src/components/HowToConnect.jsx
import React from 'react';
import './HowToConnect.css';
import { FaDiscord, FaDownload, FaGavel, FaLink, FaTerminal } from 'react-icons/fa';
import { Link } from 'react-router-dom';


const HowToConnect = () => {
  const steps = [
    {
      title: 'Instala FiveM',
      description: 'El primer paso para entrar en la ciudad es tener el cliente oficial. Descárgalo desde la web de Cfx.re.',
      buttonText: 'Descargar Cliente',
      buttonLink: 'https://fivem.net/',
      icon: <FaDownload />,
      type: 'download'
    },
    {
      title: 'Únete a nuestra Comunidad',
      description: 'El Discord es el corazón de Rias Baixas PD. Allí encontrarás la normativa, soporte y anuncios importantes.',
      buttonText: 'Entrar al Discord',
      buttonLink: 'https://discord.gg/GXr37Wr8CJ',
      icon: <FaDiscord />,
      type: 'discord'
    },
    {
      title: 'Conexión Directa',
      description: 'Usa nuestro enlace de invitación rápida para abrir FiveM y conectar automáticamente con el servidor.',
      buttonText: 'Conectar Ahora',
      buttonLink: 'fivem://connect/ervdxp',
      ipValue: 'cfx.re/join/ervdxp',
      copyLabel: 'Enlace:',
      icon: <FaLink />,
      type: 'connect'
    },
    {
      title: 'Consola de Desarrollador',
      description: 'Si tienes problemas con el enlace, abre FiveM, pulsa F8 y pega el comando de conexión directa.',
      ipValue: 'connect ervdxp',
      copyLabel: 'Comando:',
      icon: <FaTerminal />,
      type: 'console'
    },

    {
      title: 'Repasa la Normativa',
      description: 'Antes de entrar, asegúrate de conocer las leyes de la ciudad para evitar sanciones administrativas.',
      buttonText: 'Ver Normas',
      buttonLink: '/normativa',
      icon: <FaGavel />,
      type: 'rules'
    }
  ];

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => alert('¡Copiado con éxito!'))
      .catch(() => alert('Error al copiar.'));
  };

  return (
    <section className="how-to-connect-section">
      <div className="connect-content-wrapper">
        <h1 className="connect-title" data-aos="zoom-in">Guía de Conexión</h1>
        
        <div className="connect-steps-container">
          {steps.map((step, index) => (
            <div 
              key={index} 
              className="step-card-premium visible" 
              data-aos="fade-up" 
              data-aos-delay={index * 100}
            >
              <div className="step-number-wrapper">
                {index + 1}
              </div>
              
              <div className="step-content-glass">
                <h2>{step.title}</h2>
                <p>{step.description}</p>
                
                {step.ipValue && (
                  <div className="copy-section-wrapper">
                    <div className="copy-box-premium">
                      <span className="copy-label">{step.copyLabel}</span>
                      <span className="copy-text">{step.ipValue}</span>
                      <button 
                        className="btn-copy-small"
                        onClick={() => copyToClipboard(step.ipValue)}
                      >
                        Copiar
                      </button>
                    </div>
                    {step.hint && <span className="hint-text-premium">{step.hint}</span>}
                  </div>
                )}

                {step.buttonText && (
                  step.buttonLink.startsWith('/') ? (
                    <Link 
                      to={step.buttonLink} 
                      className={`connect-action-btn ${step.type === 'rules' ? 'btn-rules-glow' : 'btn-primary-glow'}`}
                    >
                      {step.icon && <span className="step-icon-container">{step.icon}</span>}
                      {step.buttonText}
                    </Link>
                  ) : (
                    <a 
                      href={step.buttonLink} 
                      className={`connect-action-btn ${step.type === 'discord' ? 'btn-discord' : 'btn-primary-glow'}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {step.icon && <span className="step-icon-container">{step.icon}</span>}
                      {step.buttonText}
                    </a>
                  )
                )}



              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowToConnect;